package com.appcreator.blueprint.core

import io.ktor.http.decodeURLPart

fun String.urlDecode(): String = this.decodeURLPart()